/**
 * TODO: REMOVE THIS FILE AFTER BLACK FRIDAY AND CHRISTMAS
 */

import { getObjectValueByKey } from '@js/utilities/getObjectValueByKey';
import formatPrice from '@js/utilities/formatPrice';

const handleInjectData = (data, container) => {
    const elements = [...container.querySelectorAll('[data-bf-inject]')];

    const injectorTypes = {
        price: (value) => formatPrice(value),
        percent: (value) => Math.floor(value),
    };

    elements.forEach((el) => {
        const key = el.dataset.bfInject;
        const injectorType = el.dataset.bfInjectType;
        const displayIfValueExist = el.dataset.bfDisplayIfValueExist;

        let val = getObjectValueByKey(data, key);

        if (typeof injectorTypes[injectorType] === 'function') {
            val = injectorTypes[injectorType](val);
        }

        if (val) {
            if (displayIfValueExist) {
                const dVal = getObjectValueByKey(data, displayIfValueExist);
                if (Number(dVal) > 0) {
                    el.innerHTML = val;
                } else {
                    el.closest('[data-bf-inject-parent]')?.remove();
                }
            } else {
                el.innerHTML = val;
            }
        } else {
            el.closest('[data-bf-inject-parent]')?.remove();
        }
    });
};

const handleNoPromo = () => {
    const elementsToShow = document.querySelectorAll('.js-show-if-promo-doesnt-exist');

    elementsToShow.forEach((el) => {
        el.classList.remove('d-none');
    });
};

const handleProductHasNotPromo = (productData, productItemTemplate) => {
    if (!productItemTemplate) {
        return;
    }

    const elementsToShow = productItemTemplate.querySelectorAll('.js-hide-if-is-promo');
    const elementsToHide = productItemTemplate.querySelectorAll('.js-show-if-is-promo');

    elementsToShow.forEach((el) => {
        el.classList.remove('d-none');
    });

    elementsToHide.forEach((el) => {
        el.classList.add('d-none');
    });

    handleInjectData(productData, productItemTemplate);
};

const handleProductHasPromo = (productData, productItemTemplate) => {
    const elementsToShow = productItemTemplate.querySelectorAll('.js-show-if-is-promo');
    const elementsToHide = productItemTemplate.querySelectorAll('.js-hide-if-is-promo');

    elementsToShow.forEach((el) => {
        el.classList.remove('d-none');
    });

    elementsToHide.forEach((el) => {
        el.classList.add('d-none');
    });

    handleInjectData(productData, productItemTemplate);
};

const handlePromo = (data) => {
    Object.keys(data).forEach((productId) => {
        const productData = data[productId];
        const productItemTemplate = document.querySelector(
            `.js-product-item[data-product-id="${productId}"]`
        );

        const isPromoInProduct = productData.is_product_in_limited || false;

        if (isPromoInProduct) {
            handleProductHasPromo(productData, productItemTemplate);
        } else {
            handleProductHasNotPromo(productData, productItemTemplate);
        }
    });
};

const processPromoData = async () => {
    if (!window.IS_PROMO_PRODUCT_ITEM) {
        handleNoPromo();
        return;
    }

    const data = window.Badges?.promoRawByProduct || {};

    handlePromo(data);

    const timerModule = await import('@js/utilities/countdownTimer');
    timerModule.default();
};

export const initProductsListPromotion = () => {
    window.addEventListener('badges.loaded', () => {
        processPromoData();
    });
};
